import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@src/store';
import { agentActions } from '@src/store/reducers/agentReducer';
import { cloneDeep } from 'lodash';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';

@Component({
    selector: 'agent-cluster',
    template: require('./agent-cluster.component.html'),
    styles: [require('./agent-cluster.component.scss')]
})
export class AgentClusterComponent implements OnInit {
    public selectedCluster: any = {};
    public clusters: any[] = [];
    private tempCluster: any = {};
    public translations;
    private indexInList: number;

    constructor(private store: Store, private cd: ChangeDetectorRef,
                private translatePipe: TranslatePipe) {
    }

    public async ngOnInit() {
        this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']).then(value => this.translations = value);
        this.clusters = await this.store.dispatch({ type: agentActions.GET_CLUSTER_WITH_AGENT });
    }

    public getAgentCluster(selectedItem: any, indexInList: any): void {
        this.selectedCluster = selectedItem;
        this.tempCluster = cloneDeep(this.selectedCluster);
        this.indexInList = indexInList;
    }

    public save(): void {
        if (this.selectedCluster.isNew) {
            this.store.dispatch({
                type: agentActions.ADD_CLUSTER,
                payload: { cluster: this.selectedCluster }
            }).then((clusterId: any) => {
                if (clusterId) {
                    this.selectedCluster.ID = clusterId;
                    this.tempCluster.ID = clusterId;
                    delete this.selectedCluster.isNew;
                }
            });
        } else {
            this.store.dispatch({
                type: agentActions.UPDATE_CLUSTER,
                payload: { cluster: this.selectedCluster }
            });
        }
    }

    public cancel(): void {
        this.selectedCluster = cloneDeep(this.tempCluster);
    }

    public addTag(): void {
        const tag = '';
        this.selectedCluster.TagsCondition = [...this.selectedCluster.TagsCondition, tag];
        this.cd.markForCheck();
    }

    public delete(): void {
        this.store.dispatch({
            type: agentActions.DELETE_CLUSTER, payload: { clusterId: this.selectedCluster.ID }
        }).then((idDelete) => {
            if (idDelete) {
                this.clusters.splice(this.indexInList, 1);
                this.selectedCluster = this.clusters[this.indexInList];
                this.clusters = [...this.clusters];
            }
        });
    }

    public removeTag(index) {
        this.selectedCluster.TagsCondition.splice(index, 1);
    }

    public isDeleteDisabled(): boolean {
        return this.selectedCluster.ID === 1 || (this.selectedCluster.Agents && this.selectedCluster.Agents.length > 0);
    }

    public addCluster(): void {
        this.selectedCluster = {  isNew: true,
            Agents: [], AutomationHost: null, AutomationPort: 8017, IsSSL: false, Name: 'New Cluster', TagsCondition: []
        };
        this.tempCluster = { isNew: true,
            Agents: [], AutomationHost: null, AutomationPort: 8017, IsSSL: false, Name: 'New Cluster', TagsCondition: []
        };

        if (!this.clusters) {
            this.clusters = [];
        }
        this.clusters = [this.selectedCluster, ...this.clusters];
        this.indexInList = 0;
    }

    public updateTag(event, i: number): void {
        this.selectedCluster.TagsCondition[i] = event.target.value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/admin/agent-cluster/agent-cluster.component.ts